import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import axiosStatusNotificationReducer from './axiosStatusNotification';
import cookieReducer from './cookie';
import globalNotificationReducer from './globalNotification';
import loadingReducer from './loading';
import localeReducer from './locale';
import modalToggleReducer from './modalToggle';
import NotificationReducer from './notification';
import userReducer from './user';

const reducer = (history) => combineReducers({
  router: connectRouter(history),
  notification: NotificationReducer,
  locale: localeReducer,
  user: userReducer,
  loading: loadingReducer,
  axiosStatusNotification: axiosStatusNotificationReducer,
  modalToggle: modalToggleReducer,
  cookie: cookieReducer,
  globalNotification: globalNotificationReducer,
})

export default reducer;
